<div
  *ngIf="allocation.selected
  && (modelDataStatus.forEdit.active?.models.length || modelDataStatus.forEdit.sold?.models.length)
  && !show.emptyStateNoModels"
  class="vertical-container-simple column-gap-1 padding-0p3125-1-2p5-1">
  <app-selector-for-models
    [data]="modelInfo.all"
    [buttons]="selectorButtons"
    [selectedItem]="modelInfo.selected"
    [basedPeriod]="selectedPeriod"
    [periods]="periods"
    [input]="name"
    [errorMessage]="errorMessage"
    (setPeriod)="setPeriod($event, false)"
    (selectedItemChanged)="setModelInfo($event)"
    (buttonClicked)="buttonClicked($event)"
    (inputChanged)="name = $event">
  </app-selector-for-models>

  <app-commitment-allocation-model-summary
    *ngIf="modelDataStatus.forEdit.active?.models?.length"
    [allocation]="allocation.selected"
    [grandTotal]="commitmentAllocTable.grandTotal"
    [isEdit]="isEditModel"
    (opExChanged)="setOpEx($event)">
  </app-commitment-allocation-model-summary>

  <div class="main vertical-container-simple column-gap-1">
    <app-tabs [tabNamesRaw]="tabNames" (selectedTabEmitter)="setSelectedTab($event)"></app-tabs>
    <app-commitment-allocation-model-table
      #commitmentAllocTable
      class="green-scroll"
      [selectedOrg]="selectedOrganization"
      [modelData]="modelDataStatus.forEdit"
      [isEditModel]="isEditModel"
      [selectedPeriod]="selectedPeriod"
      [allowSave]="allowSave"
      [periods]="periods"
      [selectedTab]="selectedTab"
      (roundInvestmentChanged)="countFollowOnAllocation()"
      (countTotal)="countEditableTotals()"
      (newInvestmentEmitter)="addNewInvestment()">
    </app-commitment-allocation-model-table>
  </div>

  <div class="vertical-container-simple font-4 black-10">
    <span> <span class="bold500">This model </span>{{labelsText.info}}</span>
    <span> <span class="bold500">Please note: </span>{{labelsText.disclaimer}}</span>
  </div>
</div>

<app-close-modal
  *ngIf="show.unsavedChangesModal"
  (closeModal)="closeCancelModal($event)">
</app-close-modal>

<app-no-prediction-model
  *ngIf="show.emptyStateNoPortfolio"
  [isAdmin]="isAdmin"
  [heading]="isAdmin ? 'Your portfolio is empty.' : 'Portfolio is empty.'">
</app-no-prediction-model>

<app-empty-state-create
  *ngIf="show.emptyStateNoModels && !show.emptyStateNoPortfolio"
  [isAdmin]="isAdmin"
  [title]="'Commitment allocation model'"
  [description]="labelsText.disclaimer"
  [placeholder]="'Model name'"
  [iconNameAndStyling]="'prediction-models.svg; icon-size-3p125 black-7'"
  (createButtonClick)="onModelNameEmit($event)">
</app-empty-state-create>

<app-modal-dialog
  *ngIf="show.modalThinkTwice"
  [header]="'Delete model'"
  [addAdditionalText]="true"
  [mainText]="deleteModalTextList"
  (isConfirmed)="delete($event)">
</app-modal-dialog>
